module.exports = __webpack_public_path__ + "files/6550ac3cf01e8c2689fbd0210b81dbeb.svg";